"use client"

import { Img } from "@/components/ui/image"
import { AppChannel } from "@/config/channel"
import { useConfigParams } from "@/hooks"
import { triggerSurveyBasedOnPathnamePS } from "@/lib/sandsiv/survey-utils-ps"
import Link from "next/link"
import { BaseCloseButton } from "../base-close-button"
import { AppChannelsWithoutHeader } from "../factory-header"
import { useCloseWithSurveyAction } from "../header-hooks"
import { SiteHeader } from "../site-header"

const PokerstarsHeader = ({ isThankYouPage }: { isThankYouPage?: boolean }) => {
  /*--------------------hooks--------------------*/
  const { channel } = useConfigParams()

  const handleCloseClick = useCloseWithSurveyAction(
    !!isThankYouPage,
    triggerSurveyBasedOnPathnamePS,
  )

  /*--------------------config--------------------*/
  const isLinkHeader = channel === AppChannel.PortaleWebFullResponsiveWwwSisalIt
  const hideSiteHeader =
    channel != null && AppChannelsWithoutHeader.includes(channel)

  if (hideSiteHeader) return null

  return (
    <SiteHeader>
      {isLinkHeader ? (
        <Link href={{ href: window.APP_MAIN_SITE_HOMEPAGE }} title="Pokerstars">
          <AppLogo />
        </Link>
      ) : (
        <AppLogo />
      )}
      <BaseCloseButton onClick={handleCloseClick} />
    </SiteHeader>
  )
}

function AppLogo() {
  return (
    <Img
      src="/logo/logo-pokerstars.svg"
      alt="logo"
      width={114}
      height={20}
      className="max-h-7"
    />
  )
}

export { PokerstarsHeader }
